import React, { createContext, useContext, useEffect, useState } from "react";
import AxiosService from "../Utils/AxiosService";

const RestrictedFieldsContext = createContext([]);

export const useRestrictedFields = () => useContext(RestrictedFieldsContext);

export const RestrictedFieldsProvider = ({ children }) => {
  const [restrictedList, setRestrictedList] = useState([]);
  const apiService = new AxiosService();

 useEffect(() => {
  async function fetchRestrictedFields() {
    try {
      const fields = await apiService.getFieldVisibility();
      console.log("Restricted fields API:", fields);

      // if backend returns an array of objects { field: "..." }
      if (Array.isArray(fields)) {
        setRestrictedList(fields.map((row) => row.field));
      } else if (fields && Array.isArray(fields.data)) {
        // if wrapped inside "data"
        setRestrictedList(fields.data.map((row) => row.field));
      } else {
        console.warn("Unexpected API response format", fields);
      }
    } catch (err) {
      console.error("Failed to fetch restricted fields", err);
    }
  }

  fetchRestrictedFields();
}, []);


  return (
    <RestrictedFieldsContext.Provider value={restrictedList}>
      {children}
    </RestrictedFieldsContext.Provider>
  );
};
